// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b3802b91","159":"0b083b7f","180":"85f77592","187":"95554b8d","213":"737a685f","239":"4cc27411","396":"a358131c","672":"f485bd79","708":"4dbab696"}[chunkId] + ".chunk.js";
};